






















































const PAGE_INDEX: number = 1;
const PAGE_SIZE: number = 20;
const RANK: number = 2;
import { Component, Vue, Watch, Provide } from "vue-property-decorator";
import { timeFormat, downloadFile } from "@/utils/index";
@Component({
  name: "RepayPrincipal",
})
export default class RepayPrincipal extends Vue {
  @Provide() private country: any = localStorage.getItem("country"); // 国家，字段差异化展示
  @Provide() private token: any = "";
  @Provide() private userid: any = "";
  @Provide() private isSearchFormActionDone: boolean = false; // 查询loading
  @Provide() private pageIndex: number = PAGE_INDEX;
  @Provide() private pageSize: number = PAGE_SIZE;
  @Provide() private rank: number = RANK;
  @Provide() private searchForm: any = {
    orderId: null, // 借款ID
  };
  @Provide() private columns: Array<Object> = [
    {
      prop: "jsIndex",
      label: "performance.jsIndex",
      width: "80",
      key: "col-1",
    },
    {
      prop: "ticketid",
      label: "工单ID",
      width: "120",
      key: "col-2",
    },
    {
      prop: "orderid",
      label: "ticket.loanID",
      //  width: '',
      key: "col-3",
    },
    {
      prop: "employeeid",
      label: "Dialer.staffID",
      //  width: '',
      key: "col-4",
    },
    {
      prop: "name",
      label: "performance.name",
      //  width: '',
      key: "col-5",
    },
    {
      prop: "ctime",
      label: "performance.businessTime",
      //  width: '',
      key: "col-6",
    },
    {
      prop: "repayamount",
      label: "performance.repayAmount",
      //  width: '',
      key: "col-7",
    },
    {
      prop: "repaytime",
      label: "performance.repayTime",
      //  width: '',
      key: "col-8",
    },
  ];
  @Provide() private resultData: any = [];

  // methods
  private created() {
    this.token = localStorage.getItem("token");
    this.userid = localStorage.getItem("userid");
    this.getTableList(); // 获取列表数据
  }
  private getParams() {
    const params = {
      ...this.searchForm,
      itemId: Number(this.$route.query.ticketitemid),
      Timerange: this.$route.query.date,
      Userid: Number(this.$route.query.adminuid),
      pageIndex: this.pageIndex,
      pageSize: this.pageSize,
      sort: "",
      rank: this.rank, // 1 顺序，2 倒叙
    };
    return params;
  }
  private async getTableList() {
    const params = this.getParams();
    const { getRepayPrincipal }: any = await import(
      "@/request/getRepayPrincipal"
    );
    console.log(getRepayPrincipal, "import");
    let res = await getRepayPrincipal(params, this);
    console.log(res, params, "getRepayPrincipal");
    if (res && res.listList) {
      this.resultData = res.listList.map((item: any, index: number) => {
        const temp = {
          jsIndex: index + 1,
          repaytime: item.repaytime && timeFormat(item.repaytime),
          ctime: item.ctime && timeFormat(item.ctime),
        };
        return Object.assign({}, item, temp);
      });
    }
  }
  private sortChange(val: any) {
    console.log(val, "val");
  }
  private searchFormAction() {
    // 搜索
    // if(this.testSearchForm()) {
    //   this.isSearchFormActionDone = true;
    //   this.pageIndex = 1;
    //   if(this.isHoured){
    //     this.RangeType = 3;
    //   }else{
    //     this.RangeType = 4;
    //   }
    //   this.getTableList();
    // }
  }
  private async exportFormAction() {
    // 导出数据
    const params = this.getParams();
    const { exportRepayPrincipal }: any = await import(
      "@/request/getRepayPrincipal"
    );
    let response = await exportRepayPrincipal(params, this);
    console.log(response);
    // return
    if (response) {
      if (response.filechunk) {
        let bStr = atob(response.filechunk),
          n = bStr.length,
          unit8Array = new Uint8Array(n);
        while (n--) {
          unit8Array[n] = bStr.charCodeAt(n);
        }
        const blob = new Blob([unit8Array], {
          type: "application/vnd.ms-excel;charset=utf-8",
        });
        downloadFile(blob, response.filename);
      }
    }
  }
}
